import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAJJxH7BHTEUFtNM7VgQ_A16B0B9T8Naww",
  // Must match the app's hosted origin so signInWithRedirect doesn't have to
  // relay credentials cross-origin, and so Google's consent screen shows our
  // domain instead of gnosis-bjj.firebaseapp.com. nginx.conf proxies
  // /__/auth/* and /__/firebase/* to gnosis-bjj.firebaseapp.com so the
  // handler resolves on our origin in production. Dev (Vite) has no such
  // proxy, so it keeps the firebaseapp.com domain.
  authDomain: import.meta.env.PROD ? window.location.hostname : "gnosis-bjj.firebaseapp.com",
  projectId: "gnosis-bjj",
  storageBucket: "gnosis-bjj.firebasestorage.app",
  messagingSenderId: "14805730153",
  appId: "1:14805730153:web:83a4741bd1a7574f55b3f8",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const googleProvider = new GoogleAuthProvider();
